export default function isScaMessageEvent(event = {}) {
  if (!event) return false;
  const isSameOrigin = event.origin === window.location.origin;
  const isTypeMessage = event.type === "message";
  const hasScaData = !!event.data && !!event.data.scaData;
  return hasScaData && isSameOrigin && isTypeMessage;
}
